import { supabase } from '../lib/supabase';
import emailService from './emailService';

/**
 * Account Activity Service for tracking user activities
 */
class AccountActivityService {
  /**
   * Log account activity
   */
  async logActivity(userId, activityData) {
    try {
      const { data, error } = await supabase?.from('account_activity')?.insert({
          user_id: userId,
          activity_type: activityData?.activityType,
          description: activityData?.description,
          ip_address: activityData?.ipAddress,
          user_agent: activityData?.userAgent,
          location: activityData?.location,
          metadata: activityData?.metadata
        })?.select()?.single();

      if (error) throw error;

      // Send email for important activities
      const importantActivities = ['login', 'password_change', '2fa_enabled', '2fa_disabled', 'security_alert'];
      if (importantActivities?.includes(activityData?.activityType)) {
        emailService?.sendAccountActivity(userId, {
          activityType: activityData?.activityType,
          description: activityData?.description,
          ipAddress: activityData?.ipAddress,
          location: activityData?.location
        });
      }

      return { data, error: null };
    } catch (error) {
      console.error('Failed to log activity:', error);
      return { data: null, error: error?.message };
    }
  }

  /**
   * Get user activity log
   */
  async getUserActivity(userId, limit = 20) {
    try {
      const { data, error } = await supabase?.from('account_activity')?.select('*')?.eq('user_id', userId)?.order('created_at', { ascending: false })?.limit(limit);

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Failed to fetch activity:', error);
      return { data: null, error: error?.message };
    }
  }
}

export default new AccountActivityService();